export const profile = {
  'profile.theClubUserProfile.title': 'Club-Benutzerprofil',
  'profile.theClubUserProfile.userStatus': 'Benutzerstatus',
  'profile.theClubUserProfile.username': 'Benutzername',
  'profile.theClubUserProfile.memberSince': 'Mitglied Seit',
  'profile.theClubUserProfile.sponsor': 'Sponsor',
  'profile.theClubUserProfile.referralLink': 'Empfehlungslink',
  'profile.theClubUserProfile.commissionModel': 'Provisionsmodell',
  'profile.theClubUserProfile.commissionLevels': 'Provisionsstufen',
  'profile.theClubUserProfile.commissionlevel': 'Stufe',
  'profile.theClubUserProfile.rank': 'Rang',
  'profile.theClubUserProfile.copyTooltip': 'In die Zwischenablage kopiert!',
  'profile.theClubUserProfile.copyReferralLink': 'Empfehlungslink kopieren',
  'profile.theClubUserProfile.userInformation': 'Benutzerinformationen',
  'profile.personalInformation.title': 'Meine Persönlichen Informationen',
  'profile.personalInformation.firstName': 'Vorname',
  'profile.personalInformation.lastName': 'Nachname',
  'profile.personalInformation.email': 'E-Mail',
  'profile.personalInformation.phone': 'Telefon',
  'profile.personalInformation.dateOfBirth': 'Geburtsdatum',
  'profile.personalInformation.gender': 'Geschlecht',
  'profile.personalInformation.country': 'Land',
  'profile.personalInformation.address': 'Adresse',
  'profile.personalInformation.city': 'Stadt',
  'profile.personalInformation.postalCode': 'Postleitzahl',
  'profile.personalInformation.edit': 'Bearbeiten',
  'profile.personalInformation.save': 'Speichern',
  'profile.personalInformation.cancel': 'Abbrechen',
  'profile.personalInformation.male': 'Männlich',
  'profile.personalInformation.female': 'Weiblich',
  'profile.personalInformation.other': 'Andere',
  'profile.personalInformation.saving': 'Speichere...',
  'profile.personalInformation.selectGender': 'Geschlecht wählen',
  'profile.personalInformation.saveChanges': 'Änderungen speichern',
  'profile.paymentMethods.title': 'Meine Zahlungsmethoden',
  'profile.paymentMethods.cryptoWallet': 'Krypto-Wallet',
  'profile.paymentMethods.bankAccount': 'Bankkonto',
  'profile.paymentMethods.network': 'Netzwerk',
  'profile.paymentMethods.currency': 'Währung',
  'profile.paymentMethods.address': 'Adresse',
  'profile.paymentMethods.accountNumber': 'Kontonummer',
  'profile.paymentMethods.routingNumber': 'Bankleitzahl',
  'profile.paymentMethods.bankName': 'Bankname',
  'profile.paymentMethods.accountHolderName': 'Kontoinhaber',
  'profile.paymentMethods.swiftCode': 'SWIFT-Code',
  'profile.paymentMethods.edit': 'Bearbeiten',
  'profile.paymentMethods.save': 'Speichern',
  'profile.paymentMethods.cancel': 'Abbrechen',
  'profile.paymentMethods.cryptoWalletHeader': 'Kryptowährungsgeldbörse',
  'profile.paymentMethods.bankAccountHeader': 'Bankkonto-Details',
  'profile.paymentMethods.selectNetwork': 'Netzwerk wählen',
  'profile.paymentMethods.selectCurrency': 'Währung wählen',
  'profile.paymentMethods.walletAddressPlaceholder': 'Wallet-Adresse',
  'profile.paymentMethods.accountNumberPlaceholder': 'Kontonummer',
  'profile.paymentMethods.bankNamePlaceholder': 'Bankname',
  'profile.paymentMethods.accountHolderPlaceholder': 'Kontoinhaber-Name',
  'profile.paymentMethods.routingNumberPlaceholder': 'Bankleitzahl',
  'profile.paymentMethods.swiftCodePlaceholder': 'SWIFT/BIC-Code',
  'profile.referralLink.title': 'Mein Empfehlungslink',
  'profile.referralLink.description': 'Verwende deinen Empfehlungslink, um Familienmitglieder, Freunde und Kollegen einzuladen, The Club beizutreten. Wenn sie sich über deinen Link anmelden, verdienst du Provisionen aus ihren Gewinnen entsprechend deinem Provisionsmodell.',
  'profile.referralLink.howToUse': 'So verwenden Sie Ihren Empfehlungslink:',
  'profile.referralLink.step1': 'Kopieren Sie Ihren einzigartigen Empfehlungslink unten',
  'profile.referralLink.step2': 'Teile ihn mit Personen, die du kennst und die sich für Investitionen und Handel interessieren',
  'profile.referralLink.step3': 'Wenn sie sich über deinen Link registrieren, werden sie Teil deiner Community',
  'profile.referralLink.step4': 'Verdiene Provisionen aus ihren Gewinnen basierend auf deiner Provisionsstruktur',
  'profile.referralLink.yourLink': 'Ihr Empfehlungslink',
  'profile.referralLink.partnerLink': 'Partner-Empfehlungslink',
  'profile.referralLink.partnerDescription': 'Teilen Sie diesen Link mit Personen, die ihr eigenes Empfehlungsnetzwerk aufbauen möchten. Sie erben Ihren Provisionsplan.',
  'profile.referralLink.clientLink': 'Kunden-Empfehlungslink',
  'profile.referralLink.clientDescription': 'Teilen Sie diesen Link mit Personen, die nur investieren möchten. Sie haben kein Empfehlungsnetzwerk.',
  'profile.referralLink.notAvailable': 'Empfehlungslinks sind für Ihren Kontotyp nicht verfügbar.',
  'profile.referralLink.copyTooltip': 'In die Zwischenablage kopiert!',
  'profile.referralLink.copyReferralLink': 'Empfehlungslink kopieren',
  'profile.referralLink.tipsForSuccessTitle': 'Tipps für den Erfolg:',
  'profile.referralLink.tipsForSuccessTip1': 'Teile deinen Link mit Personen, die wirklich an Investitionen und Handel interessiert sind',
  'profile.referralLink.tipsForSuccessTip2': 'Erkläre die Vorteile des Beitritts zu The Club und wie unsere Investmentprogramme funktionieren',
  'profile.referralLink.tipsForSuccessTip3': 'Seien Sie verfügbar, um Fragen zu beantworten und Ihren Empfehlungen Unterstützung zu bieten',
  'profile.referralLink.tipsForSuccessTip4': 'Überwachen Sie Ihre Provisionseinnahmen im Abschnitt "Meine Gewinne"',
  'profile.common.loading': 'Laden...',
  'profile.common.error': 'Fehler beim Laden der Daten',
  'profile.common.noData': 'Keine Daten verfügbar',
  'profile.common.updateSuccess': 'Informationen erfolgreich aktualisiert',
  'profile.common.updateError': 'Fehler beim Aktualisieren der Informationen',
  'profile.common.defaultUser': 'Benutzer',
  'profile.common.defaultUsername': 'benutzername',
  'profile.common.userMustBeActive': 'Benutzer muss aktiv sein',
  'profile.errorHandling.fillRequiredFields': 'Bitte füllen Sie alle Pflichtfelder korrekt aus',
  'profile.validation.firstName': 'Vorname',
  'profile.validation.lastName': 'Nachname',
  'profile.validation.country': 'Land',
  'profile.validation.address': 'Adresse',
  'profile.validation.city': 'Stadt',
  'profile.validation.accountNumber': 'Kontonummer',
  'profile.validation.bankName': 'Bankname',
  'profile.validation.accountHolderName': 'Kontoinhaber-Name',
  'profile.validation.routingNumber': 'Bankleitzahl',
  'profile.validation.swiftCode': 'SWIFT-Code',
  'profile.validation.required': 'ist erforderlich',
  'profile.validation.minLength': 'muss mindestens {count} Zeichen haben',
  'profile.validation.maxLength': 'darf nicht mehr als {count} Zeichen haben',
  'profile.validation.nameFormat': 'kann nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten',
  'profile.validation.phoneFormat': 'Bitte geben Sie eine gültige Telefonnummer ein',
  'profile.validation.dateOfBirth': 'Muss ein gültiges Datum und Alter zwischen 18-100 Jahren sein',
  'profile.validation.postalCode': 'Bitte geben Sie eine gültige Postleitzahl ein',
  'profile.validation.minLengthAfterSanitization': 'muss nach der Bereinigung mindestens {count} Zeichen haben',
  'profile.validation.selectNetwork': 'Bitte wählen Sie ein Netzwerk aus',
  'profile.validation.selectCurrency': 'Bitte wählen Sie eine Währung aus',
  'profile.validation.walletAddressFormat': 'Wallet-Adresse kann nur Buchstaben und Zahlen enthalten',
  'profile.validation.accountNumberFormat': 'Kontonummer darf nur Ziffern enthalten',
  'profile.validation.bankNameFormat': 'Bankname enthält ungültige Zeichen',
  'profile.validation.accountHolderFormat': 'Kontoinhaber-Name kann nur Buchstaben, Leerzeichen, Bindestriche, Apostrophe und Punkte enthalten',
  'profile.validation.routingNumberFormat': 'Bankleitzahl muss genau 9 Ziffern haben',
  'profile.validation.swiftCodeFormat': 'Bitte geben Sie einen gültigen SWIFT/BIC-Code ein',
  'profile.toast.error': 'Fehler',
  'profile.toast.success': 'Erfolg',
  'profile.toast.validationError': 'Validierungsfehler',
};
